import { BasicComponent } from "haxt";

import "./Hero.scss";

export namespace Hero {
	export type Options = {
		align?: "left" | "center" | "right";
		classes?: { [K: string]: boolean };
	};
	export type Data = {
		badge?: string;
		title: string;
		subtitle: string;
		background: {
			type: "image" | "video";
			src: string;
			loop?: boolean;
		};
		link: string;
	}
	export type Props = {
		options: Options;
		data: Data;
	};
}
export class Hero extends BasicComponent<Hero.Props> {
	/*public render() {
		return (
			<section class="Hero">
				<div class="background">
					<img src="/images/gsi-banner-background.jpg" />
					<video autoPlay muted loop>
						<source src="/images/a.mp4" type="video/mp4" />
					</video>
				</div>
				<div class="container">
					<div class="box">
						<div class="featured">Featured</div>
						<h1>The Burren, Ireland Ancient Sea</h1>
						<p>By Dr. Keith McLemon</p>
						<a class="read-more">Read More</a>
					</div>
				</div>
			</section>
		);
	}*/

	get cls() {
		return {
			Hero: true,
			...this.props.options?.classes,
			[`align-${this.props.options?.align ?? "center"}`]: true
		};
	}

	public render() {
		let loop = (this.props.data.background.loop !== false ? { loop: true } : {});
		return (
			<section class={this.cls}>
				<div class="background">
					{this.props.data.background.type === "image" ? (
						<img src={this.props.data.background.src} />
					) : (
						<video autoPlay muted {...loop}>
							<source src={this.props.data.background.src} type="video/mp4" />
						</video>
					)}
				</div>
				<div class="container" style="visibility: hidden;">
					<div class="box">
						{/* <div class="featured">Featured</div> */}
						{this.props.data.badge && <div class="badge">{this.props.data.badge}</div>}
						<h1>{this.props.data.title}</h1>
						<p>{this.props.data.subtitle}</p>
						<a class="read-more" href={this.props.data.link}>Read More</a>
					</div>
				</div>
			</section>
		);
	}
}
